import React,{useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import emailjs from 'emailjs-com';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';



const DialogForm = ({ isOpen, onClose }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  
  const initialValues = {
    name: '',
    mobile : '',
    comment : '',
    purpose:'',
  };
  
  const phoneRegExp = /^[0-9]*$/;
    const validationSchema = Yup.object({
      name: Yup.string()
      .max(25, "maximum 25 character")
      .required("Name is required"),
    
      mobile: Yup.string()
      .required("phone number is required")
      .matches(phoneRegExp,"phone number is not valid")
      .min(10,"Too short")
      .max(10,"Too long"),
      comment: Yup.string()
      .min(4)
      .required("write a note"),
      purpose: Yup.string().required("Please select one "),
    });

    const saveData = (formData, onSuccess) => {
      emailjs.send('service_s7nrpv4', 'template_wfa5l5k', formData, 'c79Fr0K5NNIjN3ewb')
        .then((response) => {
        if(response.status === 200){
          onClose()
          setSnackbarOpen(true)
          setSnackbarMessage("Form submitted successfully, We will contact you shortly!")
          onSuccess(); 
        }
        else{
          setErrorSnackbarOpen(true)
          setSnackbarErrorMessage("Error in submitting the form, Please try again later")
        }
        })
        .catch((error) => {
          console.error('Error sending email:', error);
          setErrorSnackbarOpen(true)
          setSnackbarErrorMessage('Failed to send email. Please try again later.');
        });
    };
  
    const formik = useFormik({
      initialValues,
      validationSchema,
      onSubmit: (values, { resetForm }) => {
        saveData(values, () => resetForm()); 
      },
    });
  return (
    <div>
      <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          
          }}
          severity="success"
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={() => setSnackbarOpen(false)}
          sx={{
            marginTop: '6%', 
            marginRight: '7%'
          }}
        >
          <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          severity="error"
          open={errorSnackbarOpen}
          autoHideDuration={5000}
          sx={{
            marginTop: '6%', 
            marginRight: '7%'
          }}
          onClose={() => {setErrorSnackbarOpen(false)}}
        >
          <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
        </Snackbar>
      <Dialog open={isOpen} onClose={onClose}>
        <i className="bi bi-x" style={{ position: 'absolute', top: 0, right: 10, cursor: 'pointer', color: 'white', fontSize: '40px' }} onClick={onClose}></i>
        <DialogTitle style={{ borderRight: '60px solid rgb(134, 198, 39)', marginRight: '0px', paddingBottom: '10px' }}>Enquiries<br /><span style={{ fontSize: '15px' }}>Fill in the form below and we’ll get in touch with you</span></DialogTitle>
        <DialogContent>
    
  <form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div>
          <input type="text" class="form-control mt-2" placeholder="Name*" name="name" style={{paddingTop:'12px',paddingBottom:'12px'}}
            value={formik.values.name} onChange={formik.handleChange}
            {...formik.getFieldProps("name")}
          />
          {formik.touched.name && formik.errors.name && (
            <div style={{ fontSize: '12px' }} className="text-danger" >{formik.errors.name}</div>
          )}
        </div>
 
        <div >
          <input type="number" class="form-control mt-3" placeholder="Mobile No*" name="mobile" style={{paddingTop:'12px',paddingBottom:'12px'}}
            value={formik.values.mobile} onChange={formik.handleChange}
            {...formik.getFieldProps("mobile")}
            inputProps={{ type: "number" }}
            onKeyPress={(event) => {
              if (!phoneRegExp.test(event.key))
                event.preventDefault();
            }}
          />
          {formik.touched.mobile && formik.errors.mobile && (
            <div style={{ fontSize: '12px' }} className="text-danger">{formik.errors.mobile}</div>
          )}
        </div>
 
        <div>
          <select
            class="form-select mt-3 "
            name="purpose"
            value={formik.values.purpose}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{paddingTop:'12px',paddingBottom:'12px'}}
          >
            <option value="" label="--Please choose an option" />
            <option value="commercial" label="Commercial" />
            <option value="hospitality" label="Hospitality" />
            <option value="industrial" label="Industrial" />
            <option value="residential" label="Residential" />
            <option value="retail" label="Retail"/>
          </select>
          {formik.touched.purpose && formik.errors.purpose && (
            <div style={{ fontSize: '12px' }} className="text-danger">{formik.errors.purpose}</div>
          )}
        </div>
    
 
        <div>
          <textarea class="form-control mt-3" placeholder="Enter Message*" rows="3" name="comment"
            value={formik.values.comment} onChange={formik.handleChange}
          />
          {formik.touched.comment && formik.errors.comment && (
            <div style={{ fontSize: '12px' }} className="text-danger">{formik.errors.comment}</div>
          )}
        </div>
        <button
  style={{ width: '100%', paddingTop: '12px', paddingBottom: '12px' }}
  type="submit"
  className="btn btn-dark mt-3 mb-3"
  id="submit-button"
  disabled={!formik.isValid}
>
  Submit
</button>
    </div>
    </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DialogForm;
